import _extends from "@babel/runtime/helpers/extends";
import { withZones } from '@beef/react/enhancers';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import classNames from 'classnames/bind';
import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import { EZIndices } from "../constants";
import { getPortalContainer } from "../../utils/window";
import { EChild } from "./constants";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var ModalLayout = withZones(Object.keys(EChild))( /*#__PURE__*/memo(function (props) {
  var zones = props.zones,
    className = props.className,
    contentProps = props.contentProps,
    wrapperProps = props.wrapperProps,
    headerProps = props.headerProps;
  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", _extends({
    "aria-modal": "true",
    style: {
      zIndex: EZIndices.Default
    }
  }, wrapperProps, {
    className: cn('wrapper', cnComponentsTheme(), wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.className),
    "data-t-id": "components-ModalLayout"
  }), /*#__PURE__*/React.createElement("div", _extends({
    style: {
      zIndex: EZIndices.Header
    }
  }, headerProps, {
    className: cn('header', headerProps === null || headerProps === void 0 ? void 0 : headerProps.className)
  }), zones[EChild.Header]), /*#__PURE__*/React.createElement("div", _extends({
    className: cn('content', className, contentProps === null || contentProps === void 0 ? void 0 : contentProps.className)
  }, contentProps), zones[EChild.Content], zones[EChild.Buttons] && /*#__PURE__*/React.createElement("div", {
    className: cn('buttons')
  }, zones[EChild.Buttons]))), getPortalContainer());
}));